(() => {
  if (customElements.get('cahve-cart-recommendations')) return;

  class CahveCartRecommendations extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-cahve-cart-recommendations-track]');
      this.previousButton = this.querySelector('[data-cahve-cart-recommendations-scroll="prev"]');
      this.nextButton = this.querySelector('[data-cahve-cart-recommendations-scroll="next"]');
      if (!this.track) return;

      this.onClick = (event) => {
        const control = event.target.closest('[data-cahve-cart-recommendations-scroll]');
        if (!control) return;

        const firstItem = this.track.querySelector('.cahve-cart-recommendations__item');
        const gap = Number.parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
        const distance = (firstItem?.getBoundingClientRect().width || this.track.clientWidth) + gap;
        const direction = control.dataset.cahveCartRecommendationsScroll === 'next' ? 1 : -1;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.track.scrollBy({
          left: direction * distance,
          behavior: reducedMotion ? 'auto' : 'smooth',
        });
      };

      this.onScroll = () => window.requestAnimationFrame(() => this.updateControls());
      this.onResize = () => this.updateControls();
      this.addEventListener('click', this.onClick);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      this.updateControls();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.track?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    updateControls() {
      if (!this.track) return;
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 4;
      if (this.nextButton) this.nextButton.disabled = maxScroll <= 4 || this.track.scrollLeft >= maxScroll - 4;
    }
  }

  customElements.define('cahve-cart-recommendations', CahveCartRecommendations);
})();
